module.exports = __webpack_public_path__ + "img/logo_login.46207941.svg";